import type { Polygon } from 'shared-libs/helpers/vision/polygon-utils'

export interface BarcodeDetectionResult {
  /**
   * The decoded barcode string.
   */
  barcode: string
  /**
   * Corner points of the detected barcode.
   */
  cornerPoints: Polygon
  /**
   * Whether the detected barcode is the primary one (in case of multiple
   * simultaneous detections).
   */
  isPrimary: boolean
  /**
   * Whether the result is steady enough (undefined if not applicable).
   */
  isSteady?: boolean
  /**
   * Whether the result is large enough (undefined if not applicable).
   */
  isNear?: boolean
}

/** How many barcode polygons to check for steadiness */
export const STEADINESS_HISTORY_MAX_QUEUE_SIZE = 5

/** How many pixels a barcode can move before it's considered not steady */
export const STEADINESS_MAX_PIXELS = 8

/** How much a barcode's long edge should fill the screen. */
export const CLOSENESS_MIN_PERCENTAGE = 0.65

export function isBarcodeStable(result: BarcodeDetectionResult): boolean {
  return result.isSteady !== false && result.isNear !== false
}
